import React from 'react';
import { siteContent } from '../data/mock';
import { Check } from 'lucide-react';

export const WhatWeHandle = () => {
  const { whatWeHandle } = siteContent;

  return (
    <section className="bg-[#F5F1ED] border-b border-stone-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <h2 className="text-2xl sm:text-3xl font-bold text-stone-900">
          {whatWeHandle.title}
        </h2>
        <p className="mt-3 text-lg text-stone-600 font-medium">
          {whatWeHandle.stressRelief}
        </p>
        
        <ul className="mt-8 space-y-3">
          {whatWeHandle.items.map((item, index) => {
            const text = typeof item === 'string' ? item : item.text;
            const clarification = typeof item === 'object' ? item.clarification : null;
            return (
              <li key={index} className="flex items-start gap-3">
                <div className="w-6 h-6 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="w-4 h-4 text-[#C67F50]" />
                </div>
                <div>
                  <span className="text-stone-700">{text}</span>
                  {clarification && (
                    <p className="text-stone-500 text-sm mt-1">{clarification}</p>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
